import React from 'react';
import RegistryFacets from './RegistryFacets';

const RegistrySidebar = props => (
  <div className="col-xs-12 col-md-3 col-lg-2">
    <RegistryFacets {...props} />
  </div>
);

export default RegistrySidebar;



/** WEBPACK FOOTER **
 ** ./src/components/registry/RegistrySidebar.jsx
 **/